import React from 'react';

export const BurgerIcon = ({nameOfClass, handleClick, value}) => (
    <svg className={nameOfClass} onClick={() => handleClick(value)} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8H28M4 16H28M4 24H28" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
